<template>
    <teleport to="#modal">
        <Loading
            :visible="loading||listaMySottoProgetti.loading||listaSottoProgetti.loading"
        >
        </Loading>
        <ModalProjectFilter class="z-50"
            v-model:visible="filtri_visible"
            v-model:anno=filtri.anno
            v-model:data_inizio_dal=filtri.data_inizio_dal
            v-model:data_inizio_al=filtri.data_inizio_al
            v-model:data_fine_dal=filtri.data_fine_dal
            v-model:data_fine_al=filtri.data_fine_al
            v-model:cliente=filtri.cliente
            v-model:bu=filtri.bu
            v-model:stato="filtri.stato"
            v-model:accounts="filtri.accounts"
            v-model:direttori="filtri.direttori"
            v-model:pm="filtri.pm"
        ></ModalProjectFilter>
    </teleport>
    <div class="m-auto px-8">
        <div class="m-auto">
            <div class="flex justify-between items-center pt-10">
                <div class="flex items-center">
                    <Switcher v-model="tab_show"
                              :options="['I miei sottoprogetti', 'Tutti i sottoprogetti']"
                              class="grow whitespace-nowrap mr-3"></Switcher>

                    <div class="flex flex-col w-[400px]">
                        <Field :labelVisible="false"
                               v-model="listaSottoProgetti.search"
                               placeholder="Cerca nei sottoprogetti"></Field>
                    </div>

<!--                    <div v-show="tab_show" class="flex flex-col w-[400px]">-->
<!--                        <Field :labelVisible="false" @update:modelValue="listaSottoProgetti.debounceSearch"-->
<!--                               v-model="listaSottoProgetti.search"-->
<!--                               placeholder="Cerca nei sottoprogetti"></Field>-->
<!--                    </div>-->
                    <div class="flex">
                        <i @click="filtri_visible = !filtri_visible"
                           class="pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"></i>
                        <p v-show="hasFiltri" class="cursor-pointer pl-3 font-bold text-next-atp" @click="svuotaFiltri">Svuota filtri</p>
                    </div>
                </div>
            </div>
            <!--      <Grid :cols="cols" :rows="rows"></Grid>-->
            <div v-if="!tab_show">
                <div class="flex justify-end pt-2">
                    <Paginator class="" :pagination="listaMySottoProgetti.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4"
                               v-model:cols="sottoProgettiCols"
                               :rows="listaMySottoProgetti.rows" @order-update="listaMySottoProgetti.updateCols">
                        <template v-for="(c, j) in listaMySottoProgetti.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>
                        <template v-for="(c, j) in listaMySottoProgetti.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ $filters.toDate(context.context.row.data_fine) }}
                        </template>
                        <template v-for="(c, j) in listaMySottoProgetti.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                            {{ $filters.toEuroCurrency(context.context.row.budget) }}
                        </template>
                        <template v-for="(c, j) in listaMySottoProgetti.rows" :key="j" v-slot:[`td_${j}_8`]="context">
                            <router-link :to="{name:'DettaglioSottoProgetto', params:{id:context.context.row.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center"><i
                                class="icon-chevron_destra"></i></router-link>
                        </template>
                    </NextTable>
                </div>
                <InfiniteLoading @infinite="listaMySottoProgetti.fetchNextPage"
                                 :identifier="listaMySottoProgetti.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri sottoprogetti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else>
                <div class="flex justify-end pt-2">
                    <Paginator class="" :pagination="listaSottoProgetti.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4"
                               v-model:cols="sottoProgettiCols"
                               :rows="listaSottoProgetti.rows" @order-update="listaSottoProgetti.updateCols">
                        <template v-for="(c, j) in listaSottoProgetti.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>
                        <template v-for="(c, j) in listaSottoProgetti.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ $filters.toDate(context.context.row.data_fine) }}
                        </template>
                        <template v-for="(c, j) in listaSottoProgetti.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                            {{ $filters.toEuroCurrency(context.context.row.budget) }}
                        </template>
                        <template v-for="(c, j) in listaSottoProgetti.rows" :key="j" v-slot:[`td_${j}_8`]="context">
                            <router-link :to="{name:'DettaglioSottoProgetto', params:{id:context.context.row.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center"><i
                                class="icon-chevron_destra"></i></router-link>
                        </template>
                        <!--                        <template v-for="(c, j) in sottoProgettiRows" :key="j" v-slot:[`td_${j}_7`]>-->
                        <!--                            <div @click.prevent.stop="cm_visible = c.id"-->
                        <!--                                 class="cursor-pointer block text-center inset-0 absolute flex items-center justify-center">-->
                        <!--                                <i class="block text-center icon-opzioni"></i>-->
                        <!--                                <ContextMenu-->
                        <!--                                    class="text-next-dark-gray z-10 absolute right-0 top-0 bg-white shadow"-->
                        <!--                                    :visible="cm_visible===c.id"-->
                        <!--                                    :id="c.id"-->
                        <!--                                    @update:visible="cm_visible = -1"-->
                        <!--                                    @elimina="void(0)"-->
                        <!--                                >-->
                        <!--                                </ContextMenu>-->
                        <!--                            </div>-->
                        <!--                        </template>-->
                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaSottoProgetti.fetchNextPage"
                                 :identifier="listaSottoProgetti.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri sottoprogetti.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import InfiniteLoading from "v3-infinite-loading";
import ConfermaModal from "@/components/ConfermaModal.vue";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import TopbarProgetti from "@/components/TopbarProgetti.vue";
import sottoProgettiManager from "../api/SottoProgetti";
import Switcher from "@/components/Switcher.vue";
import NextButton from "@/components/NextButton.vue";
import Lista from "@/setup/ListaCerca";
import Field from "@/components/Field.vue";
import ModalProjectFilter from "@/components/ModalProjectFilter.vue";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';

@Options({
    name: 'ListaSottoProgetti',
    components: {
        ModalProjectFilter,
        ProjectFilter: ModalProjectFilter,
        Field,
        NextButton,
        Switcher,
        TopbarProgetti,
        AlertCard,
        NextTable,
        Paginator,
        InfiniteLoading,
        ConfermaModal,
        ContextMenu,
        Loading,
    }
})
export default class ListaSottoProgetti extends Vue {

    tab_show = 0
    loading = false
    visible = false
    cm_visible = -1
    filtri_visible = false

    listaSottoProgetti: any = setup(() => Lista(sottoProgettiManager, this.sottoProgettiCols, sottoProgettiManager.sottoprogetti, 'lista_sottoprogetti'))
    listaMySottoProgetti: any = setup(() => Lista(sottoProgettiManager, this.sottoProgettiCols, sottoProgettiManager.mySottoprogetti,'lista_sottoprogetti'))

    filtri = {
        anno: '',
        data_inizio_dal: '',
        data_inizio_al: '',
        data_fine_dal: '',
        data_fine_al: '',
        cliente: '',
        bu: '',
        stato: '',
        accounts: [],
        direttori: [],
        pm: [],
    }

    svuotaFiltri() {
        this.filtri.anno = ''
        this.filtri.data_inizio_dal = ''
        this.filtri.data_inizio_al = ''
        this.filtri.data_fine_dal = ''
        this.filtri.data_fine_al = ''
        this.filtri.cliente = ''
        this.filtri.bu = ''
        this.filtri.stato = ''
        this.filtri.accounts.splice(0)
        this.filtri.direttori.splice(0)
        this.filtri.pm.splice(0)
    }

    get hasFiltri() {
        return this.filtri.anno != '' ||
            this.filtri.data_inizio_dal != '' ||
            this.filtri.data_inizio_al != '' ||
            this.filtri.data_fine_dal != '' ||
            this.filtri.data_fine_al != '' ||
            this.filtri.cliente != '' ||
            this.filtri.bu != '' ||
            this.filtri.stato != '' ||
            this.filtri.accounts.length ||
            this.filtri.direttori.length ||
            this.filtri.pm.length
    }

    @Watch('listaSottoProgetti.search')
    setFilter(new_val: any, old_val: any) {
        if(!old_val.length && this.tab_show == 0){
            this.tab_show = 1
        }
        this.listaMySottoProgetti.search = new_val
        this.listaSottoProgetti.search = new_val
        this.listaMySottoProgetti.debounceSearch()
        this.listaSottoProgetti.debounceSearch()
    }

    @Watch('filtri', {deep: true})
    filtriChange(new_value: any) {
        this.listaSottoProgetti.apiParams = this.filtri
        this.listaMySottoProgetti.apiParams = this.filtri
        this.resetView()
    }

    mounted() {
        this.listaSottoProgetti.sort = '-data_inizio'
        this.listaMySottoProgetti.sort = '-data_inizio'
        this.listaSottoProgetti.reset()
        this.listaMySottoProgetti.reset()
    }

    resetView() {
        this.listaSottoProgetti.debounceSearch()
        this.listaMySottoProgetti.debounceSearch()
    }


    sottoProgettiCols = [
        {
            name: 'Cod. commessa',
            prop: 'cod_nodo',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Titolo sottoprogetto',
            prop: 'titolo',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Committente',
            prop: 'committente_denominazione',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'BU',
            prop: 'bu_label',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Data inizio',
            prop: 'data_inizio',
            orderable: true,
            order: 2,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Data fine',
            prop: 'data_fine',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Budget',
            prop: 'budget',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark text-right',
            resizable: true
        },
        {
            name: 'Stato',
            prop: 'stato_next_descrizione',
            ordProp: 'stato',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark text-right',
            resizable: true
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },

    ]
}

</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
